import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../styles/PolicyPages.css';

const RefundsPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1 className="policy-title">Cancellation & Refunds Policy</h1>
        <p className="policy-updated">Last updated: February 2025</p>

        <section className="policy-section">
          <h2>Order Cancellations</h2>
          <p>You may request to cancel your order only if it has <strong>not yet been dispatched</strong>. To request a cancellation, please contact us immediately at <a href="mailto:support@quitstick.in">support@quitstick.in</a> with your order details. We will do our best to accommodate cancellation requests made within <strong>12 hours of placing your order</strong>.</p>
          <p>Once an order has been dispatched, it cannot be cancelled.</p>
        </section>

        <section className="policy-section">
          <h2>No Returns</h2>
          <p>Due to the personal and consumable nature of QuitStick products, <strong>we do not accept returns under any circumstances</strong>. We encourage all customers to review product details carefully before placing an order.</p>
        </section>

        <section className="policy-section">
          <h2>No Refunds</h2>
          <p>We have a <strong>strict no-refund policy</strong>. Once an order has been placed and payment has been received, refunds will not be issued — including for:</p>
          <ul>
            <li>Change of mind</li>
            <li>Incorrect orders placed by the customer</li>
            <li>Discomfort with or dislike of the product</li>
            <li>Delay in delivery due to courier or logistics issues</li>
          </ul>
        </section>

        <section className="policy-section highlight-section">
          <h2>Exceptions — Damaged or Defective Products</h2>
          <p>We take quality seriously. If your order arrives damaged, defective, or if you receive an incorrect product, please contact us at <a href="mailto:support@quitstick.in">support@quitstick.in</a> within <strong>48 hours of delivery</strong> with:</p>
          <ul>
            <li>Your order number</li>
            <li>A clear photograph of the damaged or incorrect product</li>
            <li><strong>A mandatory unboxing video</strong></li>
          </ul>
          <div className="important-note">
            <p><strong>Unboxing Video Requirement:</strong> To process any replacement claim for damaged or incorrect items, an unboxing video is mandatory. Please record the opening of your package clearly showing the condition of the seal and the contents from the moment you begin opening it. Claims submitted without an unboxing video cannot be processed. This policy exists to ensure fair and transparent resolution for all customers.</p>
          </div>
          <p>We will review your claim and, at our sole discretion, offer a replacement for verified cases of damage or defect. Replacements are subject to product availability.</p>
        </section>

        <section className="policy-section">
          <h2>Lost Shipments</h2>
          <p>If your order is confirmed as lost by our courier partner, we will dispatch a replacement at no additional cost to you. Claims for lost shipments must be made within <strong>7 days of the expected delivery date</strong>.</p>
        </section>

        <section className="policy-section">
          <h2>Contact for Disputes</h2>
          <p>For any concerns related to your order or this policy, please reach out to us at:<br/>
          <strong>Email:</strong> <a href="mailto:support@quitstick.in">support@quitstick.in</a><br/>
          We aim to respond to all queries within 24–48 business hours.</p>
        </section>
      </div>
      
      <Footer />
    </div>
  );
};

export default RefundsPolicy;
